import { ScaledImage } from '@/features/exchange-sub-account/screens/components/ScaledImage';
import { SxProp, useDripsyTheme, View } from 'dripsy';

interface AttachmentViewerProps {
  width?: number | string;
  height?: number;
  padding?: number;
  imageUrl: string;
}

export const AttachmentViewer: React.FC<AttachmentViewerProps> = ({ width, height, padding, imageUrl }) => {
  const { container } = styles;
  const { theme } = useDripsyTheme();
  const { $radius2, $100, $5 } = theme.space || ({} as any);
  const heightView = height ?? $100;
  const paddingView = padding ?? $5;
  return (
    <View sx={{ ...container, ...{ borderRadius: $radius2 as number, width: width ?? $100, height: heightView, padding: paddingView } }}>
      <ScaledImage uri={imageUrl} height={heightView - paddingView * 2} />
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    backgroundColor: '$backgroundSecondary',
    alignItems: 'center',
    overflow: 'hidden'
  }
};
